import React, { Component } from 'react';
import { PageLayout, ContentTemplate } from '../../common/components/layout';
import NoticeListContainer from './components/NoticeListContainer';
import { NoticeConstants } from '../CustomerConstants';

class NoticeList extends Component {
  render() {
    return (
      <PageLayout>
        <ContentTemplate>
          <NoticeListContainer {...this.props} {...NoticeConstants} />
        </ContentTemplate>
      </PageLayout>
    );
  }
}

export default NoticeList;
